import { css } from "@emotion/react";
import { bpoints } from "../../../../../Utils";

export function backgroundCSS() {
    return css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;

        @media (max-width: ${bpoints.tablet.w}px){
            display: none;
        }

        .backgroundLine{
            width: 285px;
            height: 1.5px;
            background: linear-gradient(90deg, rgba(32, 75, 123, 0.00) 0%, #204B7B 19.27%, #32B8DF 48.96%, #00BA6E 80.73%, rgba(0, 186, 110, 0.00) 98.44%);
        }

        .BottomLeftText{
            color: #21588C; 
            font-size: calc(0.7rem + 0.5vw); 
            font-weight: 600; 
        }
    `;
}